var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.7 200.7",
    style: {
      enableBackground: "new 0 0 200.7 200.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7931A;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.7,124.6c-13.4,53.8-67.9,86.5-121.6,73.1C22.3,184.3-10.4,129.9,3,76.1C16.4,22.3,70.9-10.4,124.6,3 C178.4,16.4,211.1,70.9,197.7,124.6L197.7,124.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.6,86.1c2-13.4-8.2-20.5-22.1-25.3l4.5-18.1l-11-2.7l-4.4,17.6c-2.9-0.7-5.9-1.4-8.8-2.1l4.4-17.7l-11-2.7 l-4.5,18.1c-2.4-0.5-4.7-1.1-7-1.7l0-0.1l-15.2-3.8l-2.9,11.8c0,0,8.2,1.9,8,2c4.5,1.1,5.3,4.1,5.1,6.4l-5.1,20.6 c0.3,0.1,0.7,0.2,1.1,0.4c-0.4-0.1-0.8-0.2-1.2-0.3l-7.2,28.9c-0.5,1.4-1.9,3.4-5,2.6c0.1,0.2-8-2-8-2l-5.5,12.6l14.3,3.6 c2.7,0.7,5.3,1.4,7.8,2l-4.6,18.3l11,2.7L82,139c3,0.8,5.9,1.6,8.8,2.3l-4.5,18l11,2.7l4.6-18.3c18.8,3.6,32.9,2.1,38.8-14.9 c4.8-13.7-0.2-21.6-10.1-26.7C137.7,100.6,143.1,95.8,144.6,86.1L144.6,86.1z M119.4,121.3c-3.4,13.7-26.4,6.3-33.9,4.4l6-24.2 C99.1,103.4,123,107.1,119.4,121.3L119.4,121.3z M122.8,85.9c-3.1,12.4-22.3,6.1-28.5,4.6l5.5-22C106.1,70,126.1,72.9,122.8,85.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/bitcoin_icon.64244e1f5c642b6b6c5df15339fee8d5.svg";
export { ForwardRef as ReactComponent };